import BestAirlines from "./BestAirlines";

export default BestAirlines;
